import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Eye, Package, Pencil, Settings, Trash2, X, type LucideIcon } from 'lucide-react';

import { Button } from './ui';

type ActionVariant = 'secondary' | 'ghost' | 'danger';
type ActionIconName = 'view' | 'manage' | 'edit' | 'delete' | 'close' | 'products';

const actionIcons: Record<ActionIconName, LucideIcon> = {
  close: X,
  delete: Trash2,
  edit: Pencil,
  manage: Settings,
  products: Package,
  view: Eye,
};

export function ActionIconButton({
  className,
  icon,
  label,
  variant = 'ghost',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ActionIconName;
  label: string;
  variant?: ActionVariant;
}) {
  const Icon = actionIcons[icon];

  return (
    <Button
      {...props}
      aria-label={label}
      className={['icon-action-button', className].filter(Boolean).join(' ')}
      title={label}
      variant={variant}
    >
      <Icon aria-hidden="true" className="icon-action-button__icon" />
    </Button>
  );
}

export function DataViewActionCell({ children }: { children: ReactNode }) {
  return <div className="data-view-action-cell">{children}</div>;
}
